"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identity = void 0;
const HashedObject_1 = require("../model/HashedObject");
class Identity extends HashedObject_1.HashedObject {
    constructor() {
        super();
    }
    static fromKeyPair(info, keyPair) {
        let id = Identity.fromPublicKey(info, keyPair.makePublicKey());
        id.addKeyPair(keyPair);
        return id;
    }
    static fromPublicKey(info, publicKey) {
        let id = new Identity();
        id.info = info;
        id.publicKey = publicKey;
        return id;
    }
    init() {
    }
    async validate() {
        return true;
    }
    getClassName() {
        return Identity.className;
    }
    verifySignature(text, signature) {
        if (this.publicKey === undefined) {
            throw new Error('Cannot verify signature, Identity is uninitialized');
        }
        return this.publicKey.verifySignature(text, signature);
    }
    encrypt(text) {
        if (this.publicKey === undefined) {
            throw new Error('Cannot ecnrypt, Identity is uninitialized');
        }
        return this.publicKey.encrypt(text);
    }
    getPublicKey() {
        return this.publicKey;
    }
    getKeyPairHash() {
        return this.getPublicKey().getKeyPairHash();
    }
    addKeyPair(keyPair) {
        if (keyPair.hash() !== this.getKeyPairHash()) {
            throw new Error('Trying to add key pair to identity, but it does not match identity public key');
        }
        this._keyPair = keyPair;
    }
    hasKeyPair() {
        return this._keyPair !== undefined;
    }
    sign(text) {
        if (this._keyPair === undefined) {
            throw new Error('Trying to sign using Identity object, but no keyPair has been loaded');
        }
        return this._keyPair.sign(text);
    }
    decrypt(text) {
        if (this._keyPair === undefined) {
            throw new Error('Trying to decrypt using Identity object, but no keyPair has been loaded');
        }
        return this._keyPair.decrypt(text);
    }
}
exports.Identity = Identity;
Identity.className = 'hhs/v0/Identity';
HashedObject_1.HashedObject.registerClass(Identity.className, Identity);
//# sourceMappingURL=Identity.js.map